import { Box, Link } from '@mui/material';
import PropTypes from 'prop-types';

import CalculatorInput from './CalculatorInput';

function CalculatorInputsPanel({
  calculatorInputs,
  calculatorInternalInputs,
  onChange,
  showInternalInputs = false,
}) {
  const inputs = Object.entries(calculatorInputs).filter(
    ([, input]) => !input.skipInTheInputsPanel
  );

  const internalInputs = Object.entries(calculatorInternalInputs);

  return (
    <Box className="inputs-container">
      <Box>
        {inputs.map(i => (
          <CalculatorInput calcInput={i} onChange={onChange} key={i[0]} />
        ))}
      </Box>
      <br />

      <Box className="storage-contact">
        Looking for more storage?&nbsp;
        <Link
          href="https://www.scylladb.com/pricing#request-pricing"
          target="_blank"
          rel="noreferrer"
        >
          Contact us &gt;
        </Link>
      </Box>
      {showInternalInputs && (
        <Box>
          {internalInputs.map(i => (
            <CalculatorInput calcInput={i} onChange={onChange} key={i[0]} />
          ))}
        </Box>
      )}
    </Box>
  );
}

CalculatorInputsPanel.propTypes = {
  calculatorInputs: PropTypes.shape({}),
  calculatorInternalInputs: PropTypes.shape({}),
  onChange: PropTypes.func,
};

export default CalculatorInputsPanel;
